import { axios } from 'data';
import { Payout } from 'types/models';
import { PayoutsParams, PayoutsResponse } from 'types/services';

import { preparePaginatableParams, preparePaginatedData, prepareTimezonableParams } from './helpers';

const getPayouts = async (params: PayoutsParams = {}) => {
  params = preparePaginatableParams(params);
  params = prepareTimezonableParams(params);

  const response = await axios.get<PayoutsResponse>('/payout', { params });

  return preparePaginatedData<Payout>(response.data);
};

const payoutService = {
  getPayouts,
};

export default payoutService;
